import React, { useEffect, useState } from "react";
import { getYmaps3ReactComponents } from "../../utils/ymaps3Reactify";
import { getMapLoadErrorMessage } from "../../utils/mapLoadErrorMessage";

function YandexMapReady({ lat, lon, mapUi, nameProduction }) {
  const {
    reactify,
    YMap,
    YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer,
    YMapMarker,
  } = mapUi;

  const location = reactify.useDefault({ center: [lon, lat], zoom: 15 }, [
    lat,
    lon,
  ]);
  const markerCoords = reactify.useDefault([lon, lat], [lat, lon]);
  const [markerTextVisble, setMarkerTextVisble] = useState(false);

  return (
    <div className="site-map-container">
      <YMap location={location} mode="vector">
        <YMapDefaultSchemeLayer />
        <YMapDefaultFeaturesLayer />
        <YMapMarker coordinates={markerCoords}>
          {markerTextVisble && (
            <span className="site-map-marker-text">{nameProduction}</span>
          )}
          <div
            onMouseEnter={() => setMarkerTextVisble(true)}
            onMouseLeave={() => setMarkerTextVisble(false)}
            className="site-map-marker"
            aria-hidden="true"
          />
        </YMapMarker>
      </YMap>
    </div>
  );
}

const ProductionYandexMap = ({ lat, lon, nameProduction }) => {
  const [mapUi, setMapUi] = useState({ status: "loading" });

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const components = await getYmaps3ReactComponents();
        if (!cancelled) {
          setMapUi({ status: "ready", ...components });
        }
      } catch (error) {
        if (cancelled) {
          return;
        }
        if (process.env.NODE_ENV === "development") {
          console.error("[Yandex Maps]", error);
        }
        setMapUi({
          status: "error",
          message: getMapLoadErrorMessage(error),
        });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [lat, lon]);

  if (mapUi.status === "loading") {
    return <p className="site-map-empty site-map-status">Загрузка карты…</p>;
  }

  if (mapUi.status === "error") {
    return <p className="site-map-empty site-map-status">{mapUi.message}</p>;
  }

  return (
    <YandexMapReady
      lat={lat}
      lon={lon}
      mapUi={mapUi}
      nameProduction={nameProduction}
    />
  );
};

export default ProductionYandexMap;
